import React from 'react';

export const createLink = (row: any, rowField: string, linkText: string) => {
  const rowValue = row[rowField];

  return rowValue ? (
    <a href={rowValue} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
      {linkText}
    </a>
  ) : (
    <span>Unavailable</span>
  );
};
